import React from "react";
import classes from "./form4.module.css";

const Form4 = () => {
  return (
    <div className={classes.box}>
      <h3>تمت العملية بنجاح</h3>
      <i className="fas fa-check-circle"></i>
    </div>
  );
};

export default Form4;
